import { api, ApiRequestConfig } from 'api';
import { FetchStoreDetailProps, StoreDetail } from 'features/store/types';
import { HttpErrorResponse, ThunkConfig } from 'types/common';

export type GetStoreByIdParams = {
  host: string;
  params: FetchStoreDetailProps;
  config?: ApiRequestConfig;
};

export const getStoreById = async (
  { host, params, config }: GetStoreByIdParams,
  { rejectWithValue }: ThunkConfig,
) => {
  try {
    return await api.get<StoreDetail>(`${host}/get-store-by-id`, params, config);
  } catch (error) {
    const err = error as HttpErrorResponse;
    return rejectWithValue(err?.code || err?.status);
  }
};
